module.exports = __webpack_public_path__ + "img/map-pin.ea09fe2e.svg";